import { normalizeWeight } from '../../../components/ProductInfo/helpers';

export const normalizeVariantUpdateData = (data) => {
  if (!data?.weight) return data;
  return {
    ...data,
    weight: normalizeWeight(data.weight),
  };
};
